import api from './api'

const userSoleProprietorshipBasePath = '/api/v1/user-sole-proprietorship'

export async function getUserSoleProprietorships({ params }) {
  const resp = await api.get(`${userSoleProprietorshipBasePath}`, { params })
  return resp.data
}

export async function getUserSoleProprietorship({ userSoleProprietorshipId, params }) {
  const resp = await api.get(`${userSoleProprietorshipBasePath}/${userSoleProprietorshipId}`, { params })
  return resp.data
}

export async function createUserSoleProprietorship({ params, ...createUserSoleProprietorshipData }) {
  const resp = await api.post(`${userSoleProprietorshipBasePath}`, createUserSoleProprietorshipData, { params })
  return resp.data
}

export async function patchUserSoleProprietorship({
  userSoleProprietorshipId,
  params,
  ...userSoleProprietorshipUpdates
}) {
  const resp = await api.patch(
    `${userSoleProprietorshipBasePath}/${userSoleProprietorshipId}`,
    userSoleProprietorshipUpdates,
    { params }
  )
  return resp.data
}

export async function deleteUserSoleProprietorship({ soleProprietorshipId, params }) {
  const resp = await api.delete(`${userSoleProprietorshipBasePath}/${soleProprietorshipId}`, { params })
  return resp.data
}
